import { useMutation } from 'react-query';

import { downloadXerFile as mutationFn } from 'api/endPoints/downloadXerFile';

export const useMutationDownLoadXerFile = () => {
    return useMutation<any, QueryError, DownLoadXerFile>({
        mutationKey: ['downLoadXerFile'],
        mutationFn: (params) => mutationFn(params),
    });
};

interface DownLoadXerFile {
    id: number;
}
